import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Listings from "./pages/Listings";
import MyDeals from "./pages/MyDeals";
import Inbox from "./pages/Inbox";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ListingDetail from "./pages/ListingDetail";
import PrivateRoute from "./components/PrivateRoute";
import Perfil from "./pages/Perfil";
import Terminos from "./pages/Terminos";
import PoliticaPrivacidad from "./pages/PoliticaPrivacidad";
import PoliticaCookies from "./pages/PoliticaCookies";
import AvisoLegal from "./pages/AvisoLegal";
import Reset from "./pages/Reset";
import Premium from "./pages/Premium";
import Checkout from "./pages/Checkout";
import Seed from "./pages/SeedData";
import SeedData from "./pages/SeedData";
import WhatsAppButton from "./components/WhatsAppButton";
import Publicar from "./pages/Publicar";
import Success from "./pages/success"


function App() {
  const location = useLocation();
  const path = location.pathname;

  const hideNavbarRoutes = ["/login", "/register", "/legal/privacidad", "/legal/cookies", "/legal/aviso", "/reset"];
  const hideNavbar = hideNavbarRoutes.includes(path);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {!hideNavbar && <Navbar />}

      <div className="flex-1 p-6">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/terminos" element={<Terminos />} />
          <Route path="/legal/privacidad" element={<PoliticaPrivacidad />} />
          <Route path="/legal/cookies" element={<PoliticaCookies />} />
          <Route path="/legal/aviso" element={<AvisoLegal />} />
          <Route path="/reset" element={<Reset />} />
          <Route path="/premium" element={<Premium />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/seed" element={<SeedData />} />
          <Route path="/success" element={<Success />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Listings />
              </PrivateRoute>
            }
          />
          <Route path="/oferta/:id" element={<ListingDetail />} />
          <Route
            path="/ofertas"
            element={
              <PrivateRoute>
                <MyDeals />
              </PrivateRoute>
            }
          />
          <Route
            path="/buzon"
            element={
              <PrivateRoute>
                <Inbox />
              </PrivateRoute>
            }
          />
          <Route
            path="/perfil"
            element={
              <PrivateRoute>
                <Perfil />
              </PrivateRoute>
            }
          />
          <Route
            path="/publicar"
            element={
              <PrivateRoute>
                <Publicar />
              </PrivateRoute>
            }
          />


        </Routes>
      </div>

      {/* Footer aparece SIEMPRE */}
      <Footer />
      <WhatsAppButton />

    </div>
  );
}

export default App;
